module.exports = __webpack_public_path__ + "static/img/new_hosting.ba08ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_hosting.png
// module id = br2k
// module chunks = 101